// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_AGENTS } from "./action";

export function canDeleteAgents(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_AGENTS);
}
